import React, { FC } from 'react';
import { Box, Card, CardMedia, Unstable_Grid2 as Grid } from '@mui/material';
import { times } from 'lodash';

import { LoaderComponents } from 'components';
import { IMAGE_SIZE } from '../constants';

const Loader: FC = () => {
  const { Content } = LoaderComponents;

  return (
    <Grid container>
      <Grid xs={12}>
        <Content maxWidth={1160} height={52} />
      </Grid>

      {times(8, idx => (
        <Grid key={idx} xs={12}>
          <Box marginY={1}>
            <Card
              style={{
                display: 'flex',
                border: 'none',
                borderRadius: 8,
                backgroundColor: '#FBFBFB',
              }}
            >
              <CardMedia>
                <Content index={2} height={IMAGE_SIZE} maxWidth={IMAGE_SIZE} />
              </CardMedia>

              <Grid container spacing={2} direction="column" justifyContent="flex-start">
                <Grid>
                  <Box marginLeft={1} marginTop={2}>
                    <Content maxWidth={900} />
                  </Box>
                </Grid>
                <Grid>
                  <Box marginLeft={1}>
                    <Content maxWidth={900} />
                  </Box>
                </Grid>
                <Grid>
                  <Box marginLeft={1}>
                    <Content maxWidth={450} />
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default Loader;
